import { useState } from "react";
import { showToast } from "services/utils/Status";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import { checkFirstLevelApproverPermission } from "services/utils/HelperFunction";
import { IconButton, Tooltip } from "@mui/material";
import { Loader } from "components/Loader";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TablePagination from "@mui/material/TablePagination";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Alert,
  Box,
  TextField,
  Avatar,
} from "@mui/material";
import { themes } from "services/constants";
import { DialogBox } from "../DialogBox";
import { useSelector } from "react-redux";
import { ViewHistory } from "./ViewHistory";
import { leaveManagamentPlaceholder } from "services/constants/PlaceHolder";
import sessionHandling from "services/utils/notificationUtils";
import { CustomButton } from "components/CustomComponents/CustomButton";
const Pending = ({
  data,
  loading,
  onApproveClick,
  setUpdateLeaveCard,
  masterDataForSearch,
}) => {
  const { domain, token, userDetails, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [deleteConfirmation, setDeleteConfirmation] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [pastLeaveData, setPastLeaveData] = useState(null);
  const [showViewHistory, setShowViewHistory] = useState(null);
  const [rejectedReasonValidation, setRejectedReasonValidation] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [expandId, setExpendId] = useState(0);
  const handleDeleteCancel = (event) => {
    setRejectReason("");
    setDeleteConfirmation(null);
    setRejectedReasonValidation("");
  };

  const handleDeleteConfirmation = (leaveId) => {
    setDeleteConfirmation(leaveId);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) {
    return (
      <div>
        <Loader info="Loading..." />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Grid sx={{ mt: 5 }}>
        <Alert severity="info">
          {masterDataForSearch?.length === 0
            ? "No data available."
            : "No matching data found for your search."}
        </Alert>
      </Grid>
    );
  }

  const handleApproveClick = async (item, status, reason) => {
    let apiUrl = "";
    if (item.title === "Permission") {
      apiUrl = `${domain}permission_update/`;
    } else if (item.title === "Leave") {
      apiUrl = `${domain}leave_request_update/`;
    } else {
      apiUrl = `${domain}leave_request_cancel_update/`;
    }
    setButtonLoader(true);
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          id: item.id,
          approver_id: userDetails.id,
          request_status: status,
          approver_name: userDetails.first_name,
          ...(status === "Rejected" && { reason: reason }),
        }),
      });
      const res = await response.json();
      if (response.ok) {
        if (status === "Approved") {
          showToast("success", res.message);
        } else if (status === "Rejected") {
          showToast("error", res.message);
        }
        onApproveClick(item);
        setUpdateLeaveCard(true);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    } finally {
      setButtonLoader(false);
    }
  };

  const sortedData = [...data].sort(
    (a, b) =>
      new Date(a?.from_date.split("-").reverse().join("-")) -
      new Date(b?.from_date.split("-").reverse().join("-"))
  );

  const handleViewHistoryClick = (item) => {
    setPastLeaveData(item);
    setShowViewHistory(true);
    setDeleteConfirmation(null);
  };

  const onSubmit = async () => {
    if (rejectReason?.trim().length > 5 && rejectReason !== "") {
      await handleApproveClick(deleteConfirmation, "Rejected", rejectReason);
      setDeleteConfirmation(null);
      setRejectedReasonValidation("");
    } else {
      if (rejectReason === "" || !rejectReason.trim()) {
        setRejectedReasonValidation("Reason");
      } else {
        setRejectedReasonValidation("Less then 5 charactor");
      }
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Permission":
        return themes.secondryButtonColor;
      case "Leave":
        return themes.onleaveTap;
      case "Cancel":
        return themes.primaryButtonColor;
      default:
        return "black";
    }
  };

  return (
    <>
      <Grid container spacing={0} sx={{ justifyContent: "center" }}>
        {sortedData
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((item) => (
            <Grid item key={item.id}>
              <Card
                className=" max-w-fit mt-5 w-96 flex space-x-1 shadow-lg  "
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  marginLeft: 3,
                }}
              >
                <CardContent>
                  <Grid container sx={{ paddingBottom: 1 }}>
                    <Grid item xs={2}>
                      <Avatar
                        sx={{
                          backgroundColor: "#8A4402",
                        }}
                        alt={item.username?.charAt(0).toUpperCase()}
                        src={item.image_url}
                      ></Avatar>
                    </Grid>
                    <Grid item xs={7} sx={{ paddingTop: 1 }}>
                      <Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title={item?.username}
                      >
                        <Typography sx={{ paddingLeft: 2 }}>
                          {item?.username?.length > 18
                            ? item?.username.substr(0, 18) + "..."
                            : item?.username}
                        </Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={3}>
                      <Box
                        sx={{
                          width: 80,
                          height: 15,
                          backgroundColor: getStatusColor(item.title),
                          borderRadius: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: themes.backgroundWhite,
                          p: 2,
                          fontSize: 13,
                        }}
                      >
                        {item.title === "Leave"
                          ? "Leave"
                          : item.title === "Permission"
                          ? "Permission"
                          : item.title}
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={3.5}>
                      <Typography fontWeight="bold">Department</Typography>
                    </Grid>
                    <Grid item xs={0.4}>
                      <Typography fontWeight="bold">:</Typography>
                    </Grid>
                    <Grid
                      item
                      xs={8.1}
                      style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item?.department_name}
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={3.5}>
                      <Typography fontWeight="bold">Requested</Typography>
                    </Grid>
                    <Grid item xs={0.4}>
                      <Typography fontWeight="bold">:</Typography>
                    </Grid>
                    <Grid item xs={8.1}>
                      {item.title === "Permission" ? (
                        <Typography>{item.from_date}</Typography>
                      ) : (
                        <Typography>
                          {item.from_date + " To " + item.to_date}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                  <Grid container style={{ paddingBottom: 3 }}>
                    <Grid item xs={3.5}>
                      <Typography fontWeight="bold">Duration</Typography>
                    </Grid>
                    <Grid item xs={0.4}>
                      <Typography fontWeight="bold">:</Typography>
                    </Grid>
                    {item.title === "Leave" ? (
                      <Grid item xs={8.1}>
                        <Typography>
                          {" "}
                          {parseInt(item.business_days) > 1
                            ? item.business_days + " days"
                            : item.business_days + " day"}{" "}
                          {item?.half_day_period === "1st"
                            ? "  Morning"
                            : item?.half_day_period === "2nd"
                            ? "  Noon"
                            : null}
                        </Typography>
                      </Grid>
                    ) : (
                      <Grid>
                        <Typography sx={{ fontSize: 14.7, paddingTop: 0.2 }}>
                          {item.start_time + " To " + item.end_time},{" "}
                          {item.total_time + " hr"}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                  {expandId === item.id ? (
                    <>
                      <Grid container sx={{ paddingBottom: 1 }}>
                        <Grid item xs={3.5}>
                          <Typography fontWeight="bold">Description</Typography>
                        </Grid>
                        <Grid item xs={0.4}>
                          <Typography fontWeight="bold">:</Typography>
                        </Grid>
                        <Grid item xs={8.1}></Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} sx={{ paddingBottom: 1 }}>
                          <div style={{ maxWidth: 300 }}>
                            <Typography display="flex">
                              {item.description ? item.description : null}
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  ) : null}
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <IconButton
                        size="small"
                        sx={{ marginRight: 2 }}
                        onClick={() =>
                          setExpendId(item.id === expandId ? 0 : item.id)
                        }
                      >
                        {expandId === item.id ? (
                          <KeyboardArrowUpIcon
                            size="small"
                            sx={{ stroke: 2, color: themes.headLine }}
                          />
                        ) : (
                          <KeyboardArrowDownIcon
                            size="small"
                            sx={{ stroke: 2, color: themes.headLine }}
                          />
                        )}
                      </IconButton>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{
                          marginRight: 2,
                          textTransform: "capitalize",
                          borderColor: themes.dividerBorder,
                          color: themes.headLine,
                          fontWeight: "bold",
                        }}
                        onClick={() => handleViewHistoryClick(item)}
                      >
                        View History
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{
                          marginRight: 2,
                          textTransform: "capitalize",
                          borderColor: themes.dividerBorder,
                          color: themes.headLine,
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          if (
                            checkFirstLevelApproverPermission(
                              userScreenAccess?.module_details,
                              "Approve",
                              "Leaves"
                            )
                          ) {
                            handleDeleteConfirmation(item, "Rejected");
                          } else {
                            showToast(
                              "error",
                              "Access denied: You are not authorized to rejected the leave"
                            );
                          }
                        }}
                      >
                        Reject
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        sx={{
                          textTransform: "capitalize",
                          borderColor: themes.dividerBorder,
                          color: themes.headLine,
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          if (
                            checkFirstLevelApproverPermission(
                              userScreenAccess?.module_details,
                              "Approve",
                              "Leaves"
                            )
                          ) {
                            handleApproveClick(item, "Approved");
                          } else {
                            showToast(
                              "error",
                              "Access denied: You are not authorized to approve the leave"
                            );
                          }
                        }}
                      >
                        Approve
                      </Button>
                    </Box>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
      </Grid>
      {sortedData.length > 10 && (
        <TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[10, 20, 50, 100]}
          component="div"
          count={sortedData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
      <br />

      <DialogBox
        open={Boolean(deleteConfirmation)}
        onClose={handleDeleteCancel}
        title="Reason for Rejection"
      >
        <TextField
          multiline
          minRows={3}
          sx={{
            marginTop: 1,
            width: "95%",
            marginLeft: 2,
            marginRight: "auto",
          }}
          placeholder={leaveManagamentPlaceholder.rejectionLeave}
          onChange={(e) => setRejectReason(e.target.value)}
        />
        {["Reason", "Less then 5 charactor"].includes(
          rejectedReasonValidation
        ) && (
          <Typography
            variant="body2"
            color="error"
            sx={{ fontSize: 13, paddingLeft: 3, paddingTop: 0.5 }}
          >
            {rejectedReasonValidation === "Reason"
              ? "Please enter the rejected reason"
              : "Minimum 5 characters with no spaces"}
          </Typography>
        )}

        <Grid container sx={{ paddingTop: 1 }}>
          <Grid xs={8}></Grid>
          <Grid
            xs={4}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              paddingRight: 1,
            }}
          >
            <CustomButton
              actionFuntion={handleDeleteCancel}
              actionName="Cancel"
              typeName="button"
            />
            &nbsp;&nbsp;
            <CustomButton
              actionFuntion={onSubmit}
              actionName="Reject"
              disableAction={
                deleteConfirmation && buttonLoader ? buttonLoader : false
              }
              typeName="submit"
            />
          </Grid>
        </Grid>
      </DialogBox>
      {showViewHistory && (
        <ViewHistory
          historyData={pastLeaveData}
          onClose={() => setShowViewHistory(false)}
        />
      )}
    </>
  );
};

export default Pending;
